module.exports = __webpack_public_path__ + "img/skillgames-fun.0c1bd2c1.jpg";